document.addEventListener("DOMContentLoaded", () => {
  new TripsitterCTA();
});

class TripsitterCTA {
  constructor() {
    this.ctaSection = document.querySelector(".section-tripsitter-cta");
    if (!this.ctaSection) return;

    this.packages = this.ctaSection.querySelectorAll(
      ".tripsitter-cta__package"
    );
    this.addToCartButton = this.ctaSection.querySelector("#add-to-cart-button");
    this.popupTemplate = document.getElementById("ajax-cart-popup-template");

    if (!this.packages.length || !this.addToCartButton || !this.popupTemplate)
      return;

    this._initEventListeners();
  }

  _initEventListeners() {
    // Package selection logic
    this.packages.forEach((pkg) => {
      pkg.addEventListener("click", () => this._handlePackageSelect(pkg));
      pkg.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this._handlePackageSelect(pkg);
        }
      });
    });

    // Add to cart button logic
    this.addToCartButton.addEventListener("click", () =>
      this._handleAddToCart()
    );
  }

  _handlePackageSelect(selectedPkg) {
    this.packages.forEach((p) => p.classList.remove("is-selected"));
    selectedPkg.classList.add("is-selected");
  }

  _handleAddToCart() {
    const selectedPackage = this.ctaSection.querySelector(
      ".tripsitter-cta__package.is-selected"
    );
    const variantId = selectedPackage?.dataset.variantId;

    if (!variantId) {
      console.error("No package selected or variant ID is missing.");
      return;
    }

    this.addToCartButton.classList.add("is-loading");
    this.addToCartButton.disabled = true;

    const formData = { items: [{ id: variantId, quantity: 1 }] };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.status >= 400) {
          return response.json().then((err) => {
            throw new Error(err.description || "Error adding item.");
          });
        }
        return response.json();
      })
      .then((data) => {
        this._showPopup(data.items[0]);
        this._updateCartCount();
      })
      .catch((error) => {
        console.error("Error:", error);
        alert(error.message);
      })
      .finally(() => {
        this.addToCartButton.classList.remove("is-loading");
        this.addToCartButton.disabled = false;
      });
  }

  _showPopup(itemData) {
    const popupNode = this.popupTemplate.content.cloneNode(true);
    const popupWrapper = popupNode.querySelector(".cart-popup-wrapper");
    const closeButton = popupNode.querySelector(".cart-popup__close");
    const dismissButton = popupNode.querySelector(
      ".cart-popup__dismiss-button"
    );

    // Populate data
    const imageEl = popupNode.querySelector(".cart-popup-item__image");
    imageEl.src = itemData.image || '{{ "rocket-image.png" | file_url }}';
    imageEl.alt = itemData.title;
    popupNode.querySelector(".cart-popup-item__title").textContent =
      itemData.title;
    popupNode.querySelector(".cart-popup-item__quantity-value").textContent =
      itemData.quantity;

    // --- Popup Close Logic ---
    const closePopup = () => {
      document.querySelector(".cart-popup-wrapper")?.remove();
      document.removeEventListener("keydown", handleEscapeKey);
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") closePopup();
    };

    closeButton.addEventListener("click", closePopup);
    dismissButton.addEventListener("click", closePopup);
    popupWrapper.addEventListener("click", (event) => {
      if (event.target === popupWrapper) closePopup();
    });
    document.addEventListener("keydown", handleEscapeKey);

    document.body.appendChild(popupWrapper);
    closeButton.focus();
  }

  _updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const cartCountElements = document.querySelectorAll(
          ".cart-count-bubble, .site-header__cart-count, .cart-popup__cart-quantity"
        );
        cartCountElements.forEach((el) => {
          if (el) el.textContent = data.item_count;
        });
      });
  }
}
